import React, { useEffect, useState } from "react";
import { fetchHtml } from "../../lib/Fetching";

export default function GanntChartContainerView({ id, showRemovedItems = false }) {
  const [html, setHtml] = useState("");

  useEffect(
    () => {
      setHtml("");
      fetchHtml("/tracking/gannt_charts/container", {
        item_id: id,
        show_removed_items: showRemovedItems,
      }).then((html) => setHtml(html));
    },
    [id]
  );

  return (
    <div>
      {!html && <i className="fa fa-spinner fa-spin" />}
      <div dangerouslySetInnerHTML={{ __html: html }} />
    </div>
  );
}
